// generated by srcset-codegen
import src from "./youtube.png";
import src2x from "./youtube@2x.png";
import src3x from "./youtube@3x.png";

const width = 17;
const height = 12;
const srcSet = `${src2x} 2x, ${src3x} 3x`;
export default { src, width, height, srcSet };
